<ion-header [translucent]="true">
  <ion-toolbar color="primary">
    <ion-buttons slot="start">
      <ion-menu-button></ion-menu-button>
    </ion-buttons>
    <ion-title>Órarend</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content [fullscreen]="true" *ngIf="sajatIntezmeny">
  <ng-template #userMenu let-user>
    <section class="user-menu">
      <div (click)="variableInfo(user)">Variable Information</div>
      <hr>
    <div (click)="addRecord(user)">Add Record</div>
    <div (click)="editRecord(user)">Edit Record </div>
    
    
    </section>
  </ng-template>
<!-- drag-drop.component.html -->
<div id="content1">

  <div id="menu" class="row" style="text-align: center;">
    <ion-button color="light" disabled>
      <div class="custom-button-content">
        <img src="assets/icon/icons8-verified-account-96.png" width="50px">
        <ion-label>Teszteld</ion-label>
      </div>
    </ion-button>
    <ion-button color="light" disabled>
      <div class="custom-button-content">
        <img src="assets/icon/icons8-siren-96.png" width="50px">
        <ion-label>Generálás</ion-label>
      </div>
    </ion-button>
    <ion-button color="light" disabled>
      <div class="custom-button-content">
        <img src="assets/icon/icons8-flow-chart-96.png" width="50px">
        <ion-label>Korlátozások</ion-label>
      </div>
    </ion-button>
    <span style="margin:5px;border-left:2px solid #bbb;"></span>
    <ion-button color="light" (click)="openComponent('tanar')">
      <div class="custom-button-content">
        <img src="assets/icon/icons8-employee-96.png" width="50px">
        <ion-label>Tanárok</ion-label>
      </div>
    </ion-button>
    <ion-button color="light" (click)="openComponent('tanterem')">
      <div class="custom-button-content">
        <img src="assets/icon/icons8-door-96.png" width="50px">
        <ion-label>Tantermek</ion-label>
      </div>
    </ion-button>
    <ion-button color="light" (click)="openComponent('tantargy')">
      <div class="custom-button-content">
        <img src="assets/icon/icons8-copybook-96.png" width="50px">
        <ion-label>Tantárgyak</ion-label>
      </div>
    </ion-button>
    <ion-button color="light" (click)="openComponent('osztaly')">
      <div class="custom-button-content">
        <img src="assets/icon/icons8-class-96.png" width="50px">
        <ion-label>Osztályok</ion-label>
      </div>
    </ion-button>
    <span style="margin:5px;border-left:2px solid #bbb;"></span>
    <ion-button color="light" (click)="openComponent('iskola')">
      <div class="custom-button-content">
        <img src="assets/icon/icons8-school-96.png" width="50px">
        <ion-label>Iskola</ion-label>
      </div>
    </ion-button>
    <span style="margin:5px;border-left:2px solid #bbb;"></span>
    <ion-button color="light">
      <div class="custom-button-content">
        <img src="assets/icon/icons8-vision-96.png" width="50px">
    <span>Nézet:
    <select 
                  name="nezet"
                  [(ngModel)]="nezet"
                >
                  <option value="1">Osztály</option>
                  <option value="2">Tanár</option>
                  <option value="3">Tanterem</option>
                  <option value="4">Tantárgy</option>
                </select>
    </span>
  </div>
  </ion-button>
  <ion-button color="light" *ngIf="sajatIntezmeny.o_het > 1">
    <div class="custom-button-content">
      <img src="assets/icon/icons8-calendar-96.png" width="50px">
  <span>Hét:
  <select 
                name="het"
                [(ngModel)]="het"
              >
                <option *ngFor="let it of [].constructor(sajatIntezmeny.o_het); let n = index" [value]="n">{{hetek[n]}}</option>
              </select>
  </span>
</div>
</ion-button>
  </div>
  <div id="cardSlots">
    <div class="scrollable-table printable">
      <table id="printable">
        <thead>
        <tr class="green">
          <!--th>#</th-->
          <th  [attr.colspan]="1" rowspan="2"></th>
          <th  [attr.colspan]="csengetes.length" *ngFor="let it of [].constructor(sajatIntezmeny.o_napok); let n = index">{{napok[n]}}</th>
          <!--th  [attr.colspan]="csengetes.length">Kedd</th>
          <th  [attr.colspan]="csengetes.length">Szerda</th>
          <th  [attr.colspan]="csengetes.length">Csütörtök</th>
          <th  [attr.colspan]="csengetes.length">Péntek</th-->
          </tr>
          <tr class="green">
            <!--th>#</th-->
            <ng-container *ngFor="let it of [].constructor(sajatIntezmeny.o_napok); let j = index">
              <th [id]="'i'+((csengetes.length*j)+i)" *ngFor="let it of csengetes; let i = index">
                {{it.oraszam}}
                <!-- Csengetési rend: az óra kezdete és vége a fejlécben -->
                <small class="csengetes-ido" *ngIf="it.kezdes">{{ ido(it.kezdes) }}–{{ ido(it.vege) }}</small>
              </th>
            </ng-container>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let o of osztaly; let j = index">
              <td [id]="'j'+j">{{o.osztaly}}</td>
              <ng-container *ngFor="let slot of slots; let i = index">
                <ng-container *ngIf="shouldRenderCell(o.id, i)">
                  <td [style.cursor]="isSlotFilled[o.id][i] ? 'pointer':'auto'" (click)="ttModal(isSlotFilled[o.id][i],o.id,i)"
                  [id]="o.id+i"
                    [class]="utolsoOra(csengetes.length, i+1)" 
                    [style.background]="whatIsMyBg(o.id,i)" 
                    [attr.colspan]="cardInSlot[o.id][i]?.orarend ? cardInSlot[o.id][i]['orarend'].hossz : 1">
                    <div  
                      [attr.data-slot]="slot"
                      [style.background]="whatIsMyBg(o.id,i)"
                      [style.color]="'white'"
                      (drop)="onDrop($event, slot, i, o.id)" 
                      (dragover)="allowDrop($event, isSlotFilled[o.id][i], o.id, j, i)" 
                      (mouseenter)="mouseEnter(j, i)"
                      (mouseleave)="mouseLeave(j, i)"
                      class="slot">
                      <span *ngIf="isSlotFilled[o.id][i]" class="rotate">
                        <div>
                          <b>{{ cardInSlot[o.id][i].rovid }} <span *ngIf="cardInSlot[o.id][i].orarend?.locked == 1"><fa-icon [icon]="['fas','lock']"></fa-icon></span></b>
                          <br>
                          {{ allomany[cardInSlot[o.id][i].ttfel.munkatars].intezmenyadatok.kod ?? allomany[cardInSlot[o.id][i].ttfel.munkatars].oktazon }} ({{cardInSlot[o.id][i]['orarend']?.hossz}}db)
                        </div>
                      </span>
                    </div>
                  </td>
                </ng-container>
              </ng-container>
            </tr>
            
          </tbody>
      </table>
    </div>
    
  </div>
  
  <div id="cardPile">
    <!-- Create draggable cards -->
    
    <h1 *ngIf="!cards ||cards.length == 0" style="text-align: center;">Nincs beosztatlan tanóra <fa-icon [icon]="['far','face-smile']"></fa-icon></h1>
    <div *ngFor="let card of cards" 
         [attr.data-card]="card" 
         [style.background]="card.szin"
         (dragstart)="onDragStart($event, card)" 
         draggable="true" 
         [class]="'card'">
         <div [class]="cardClass(card.db)" [style.background]="card.szin">
      {{ card.rovid ?? card.nev }} ({{allomany[card.ttfel.munkatars].intezmenyadatok.kod ?? allomany[card.ttfel.munkatars].oktazon}})<br>
      {{ card.evfolyam.osztaly }}<br>
      {{ card.db }} db
    </div>
    </div>
 
  </div>
</div>


<ion-modal (willDismiss)="onWillDismiss($event)" [style.--height]="'250px'">
  <ng-template>
    <ion-header>
      <ion-toolbar [style.--background]="kivalasztottora.szin" [style.color]="'white'">
        <!--ion-buttons slot="start">
          <ion-button (click)="cancel()">Bezár</ion-button>
        </ion-buttons-->
        <ion-title
          >Tanóra: {{kivalasztottora.evfolyam.osztaly}} {{kivalasztottora.rovid ?? kivalasztottora.nev}} - {{allomany[kivalasztottora.ttfel.munkatars].intezmenyadatok.kod ?? allomany[kivalasztottora.ttfel.munkatars].oktazon}} ({{kivalasztottora.orarend.hossz}}db)</ion-title
        >
        <ion-buttons slot="end">
          <ion-button
            style="background: white;border-radius: 5px;"
            (click)="cancel()"
            [strong]="true"
            [disabled]="validateForm()"
            shape="round"
            [style.color]="kivalasztottora.szin"
            >Bezár</ion-button
          >
        </ion-buttons>
      </ion-toolbar>
    </ion-header>
    <ion-content class="ion-padding" style="margin:auto;text-align: center;">
      <ion-button size="large" [style.--background]="kivalasztottora.szin">
        Óra módosítása
        <ion-icon slot="start" name="create"></ion-icon>
      </ion-button>
      <ion-button size="large" color="warning" *ngIf="kivalasztottora.orarend?.locked != 1">
        Lezárás
        <ion-icon slot="start" name="lock-closed"></ion-icon>
      </ion-button>
      <ion-button size="large" color="dark" *ngIf="kivalasztottora.orarend?.locked == 1">
        Feloldás
        <ion-icon slot="start" name="lock-open"></ion-icon>
      </ion-button>
      <ion-button size="large" color="danger" (click)="delOrarend()" [disabled]="kivalasztottora.orarend?.locked == 1">
        Törlés
        <ion-icon slot="start" name="trash"></ion-icon>
      </ion-button>
    </ion-content>
  </ng-template>
</ion-modal>
</ion-content>